// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const apps = {
  // falcon_web: 'http://localhost:4200/login',
  falcon_web: 'https://dev-nexus.falcon.appvelsis.com',
  iot_manager: 'https://iot.appvelsis.com/CentralVelsis',
  administrador:'https://dev-nexus.administrator.appvelsis.com'

};

export const environment = {
  production: false,
  api: 'https://dev-nexus.appvelsis.com/monitoring/',
  proxy: '/proxy/service/',
  tenantId: 'f6842ee7-8e0b-4b2e-b93d-d7e542d5c34a',
  googleMapsKey: 'AIzaSyDk1O2udZedUxNsZQOsfSGkgnZ1MC581Bs',
  apiLegacy: 'https://dev-nexus.appvelsis.com/processing/',
  proxyLegacy: '/proxy/legacy/',
  deviceBuild: 'https://dev-nexus.appvelsis.com/deviceBuild/api',
  proxyDeviceBuild: '/proxy/proxyDeviceBuild/',
  apiReports: 'https://dev-nexus.appvelsis.com/',
  proxyReports: '/proxy/reports/',
  baseApi: 'https://dev-nexus.appvelsis.com/',
  proxyAuth: '/proxy/users/',
  apiProcess: 'https://dev-nexus.appvelsis.com/',
  proxyProcess: '/proxy/process/',
  apiExport: 'https://dev-nexus.appvelsis.com/',
  proxyExport: '/proxy/export/',
  apiLake: 'https://dev-nexus.appvelsis.com/datalake/',
  proxyLake: '/proxy/lake/',
  apiBuild: 'https://dev-nexus.appvelsis.com/deviceBuild/',
  proxyBuild: '/proxy/build/',
  apiAlert: 'https://dev-nexus.appvelsis.com/alertService/',
  apiPulse: 'https://dev-nexus.appvelsis.com/pulsevs/',
  apiDatagrid: 'https://dev-nexus.appvelsis.com/datagrid/',
  proxyAlert: '/proxy/alert/',
  apiMobile: 'https://dev-api.appvelsis.com/mobile/',
  proxyMobile: '/proxy/mobile/',

  apiForAuth: 'https://staging.api.pegae.xyz/v2/',
  proxyFormAuth: '/proxy/form/auth/',

  apiForAuthV1: 'https://staging.api.pegae.xyz/v1/',
  proxyFormAuthV1: '/proxy/form/authv1/',

  apiForAuthV2: 'https://staging.api.pegae.xyz/v2/',
  proxyFormAuthV2: '/proxy/form/authv2/',

  proxyWebsocket: '/proxy/websocket/',
  websocket: 'https://dev-api.appvelsis.com/websocket/ws',
  equipmentAlertWs: 'pulsevs_dev_client_connection_queue',

  apps: apps,

  features: {
    vitrine: true,
    button_export_ait: true,
    crud_isentos: true,
    triagemPermiteRecortePlaca: false,
    device_config: true,
  },
  disableProxyLocal: true,
  version: 'v1.3.850 D',
};
